import { Directive, ElementRef, Input, OnDestroy, OnInit, Renderer2 } from '@angular/core';
/**
 * Directive to style Nebular context menus dynamically
 * Specifically menu items and hover effects
 */
@Directive({
  selector: '[kveStyleContextMenu]'
})
export class StyleContextMenuDirective implements OnInit, OnDestroy {
  @Input() menuClass: string = 'custom-context-menu';
  @Input() menuBackgroundColor: string = '#ffffff';
  @Input() menuTextColor: string = '#000000';
  @Input() menuHoverBackgroundColor: string = '#f0f0f0';
  @Input() menuHoverTextColor: string = '#000000';

  private clickListener: () => void;
  private styleElement: HTMLStyleElement | null = null;
  private uniqueClass: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.uniqueClass = `custom-menu-${Math.random().toString(36).substr(2, 9)}`;
  }

  ngOnInit() {
    this.clickListener = this.renderer.listen(this.el.nativeElement, 'click', () => {
      requestAnimationFrame(() => {
        this.styleContextMenu();
        /* setTimeout(() => {
          this.styleContextMenu();
        }, 0); */
      });
    });
    /* this.el.nativeElement.addEventListener('click', () => {
      console.log('Context menu triggered');
      setTimeout(() => {
        const overlays = document.querySelectorAll('.cdk-overlay-pane');
        const lastOverlay = overlays[overlays.length - 1];
        console.log('Last Overlay:', lastOverlay);
        if (lastOverlay) {
          const menu = lastOverlay.querySelector('nb-context-menu');
          console.log('Context Menu Element:', menu);
          if (menu) {
            this.renderer.addClass(menu, this.menuClass);
            const nbMenu = menu.querySelector('nb-menu') as HTMLElement;
            console.log('nb-menu Element:', nbMenu);
            if (nbMenu) {
              // Set CSS custom properties (variables)
              // this.renderer.setProperty(nbMenu, '--menu-background-color', this.menuBackgroundColor);
              nbMenu.style.setProperty('--menu-background-color', this.menuBackgroundColor);
              // this.renderer.setProperty(nbMenu, '--menu-text-color', this.menuTextColor);
              nbMenu.style.setProperty('--menu-text-color', this.menuTextColor);
              nbMenu.style.setProperty('--background-alternative-color-1', "transparent");
              nbMenu.style.setProperty('--color-basic-300', '#747579');
              nbMenu.style.setProperty('--menu-item-divider-color', '#d7d8da');
              nbMenu.style.setProperty('--menu-item-hover-text-color', '#525355');
              // Optional: You can also set other styles directly
              // this.renderer.setStyle(nbMenu, 'border-radius', '8px');
              // this.renderer.setStyle(nbMenu, 'box-shadow', '0 4px 8px rgba(0,0,0,0.1)');
            }
          }
        }
      }, 0);
    }); */
  }
  private styleContextMenu() {
    const overlays = document.querySelectorAll('.cdk-overlay-pane');
    const lastOverlay = overlays[overlays.length - 1];

    if (lastOverlay) {
      const contextMenu = lastOverlay.querySelector('nb-context-menu');

      if (contextMenu) {
        const nbMenu = contextMenu.querySelector('nb-menu') as HTMLElement;

        if (nbMenu) {
          // Set CSS variables
          nbMenu.style.setProperty('--menu-background-color', this.menuBackgroundColor);
          nbMenu.style.setProperty('--menu-text-color', this.menuTextColor);
          nbMenu.style.setProperty('--background-alternative-color-1', "transparent");
          nbMenu.style.setProperty('--color-basic-300', '#747579');
          nbMenu.style.setProperty('--menu-item-divider-color', '#d7d8da');
          nbMenu.style.setProperty('--menu-item-hover-text-color', '#525355');

          // Add class for hover styles
          this.renderer.addClass(nbMenu, 'custom-hover-menu');
          // Add unique class
          this.renderer.addClass(nbMenu, this.uniqueClass);
          // Inject hover styles
          this.injectHoverStyles();
        }
      }
    }
  }

  private injectHoverStyles() {
    // Remove previous style element if exists
    if (this.styleElement) {
      this.renderer.removeChild(document.head, this.styleElement);
    }

    // Create new style element
    this.styleElement = this.renderer.createElement('style');

    const css = `
      .${this.uniqueClass} .menu-item {
        color: ${this.menuTextColor};
        transition: background-color 0.2s ease, color 0.2s ease;
      }

      .${this.uniqueClass} .menu-item:hover {
        background-color: ${this.menuHoverBackgroundColor} !important;
        color: ${this.menuHoverTextColor} !important;
        cursor: pointer;
      }

      .${this.uniqueClass} .menu-item:active {
        opacity: 0.9;
      }
    `;

    const textNode = this.renderer.createText(css);
    this.renderer.appendChild(this.styleElement, textNode);
    this.renderer.appendChild(document.head, this.styleElement);

    console.log('Hover styles injected:', this.uniqueClass);
  }

  ngOnDestroy() {
    // Clean up the event listener
    if (this.clickListener) {
      this.clickListener();
    }
    // Clean up injected styles
    if (this.styleElement) {
      this.renderer.removeChild(document.head, this.styleElement);
      this.styleElement = null;
    }
  }

}
